import { faUserFriends } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

interface Props {
  className?: string
  count: number
}

export default function PeopleCount({ className = "", count }: Props) {
  if (count <= 0) return null

  return (
    <span className={`grey-t flex items-center gap-[4px] text-sm font-normal ${className}`}>
      <FontAwesomeIcon icon={faUserFriends} />
      {count}
    </span>
  )
}
